import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import useWindowSize from '../../hooks/useWindowSize';

const SingleList = ({ name, slug, imageLink, handleDomainSelection, step, selected, index ,lastIndex }) => {

    const length = lastIndex + 1;
    const { width } = useWindowSize();
    const isMobile = width < 768;

    const column = index % 2;
  const row = Math.floor(index / 2);

  const isTop = row === 0;
  const isBottom = row === Math.floor((length - 1 - column) / 2);

    return (
        <div className={`flex items-center bg-[#406AFF]/10 hover:opacity-70 py-3 px-4 cursor-pointer ${ isMobile && ( isTop ? 'rounded-t-lg' : isBottom ? 'rounded-b-lg' : '')} ${ isMobile && (index !== lastIndex ? 'border-b-[1px] border-[#70AEFF]/30' : '')} ${ !isMobile && ( isTop ? 'rounded-t-lg' : isBottom ? 'rounded-b-lg' : '')} ${ !isMobile && (!isBottom &&  'border-b-[1px] border-[#70AEFF]/30')} `} onClick={() => {
            if(step === 1) {
                handleDomainSelection(slug, name)
            }else{
                handleDomainSelection(slug, index)
            }
        }}>
            <img src={imageLink} width={step === 1 ? 21 : step === 2 ? 36 : step === 3 ? 24 : 24} height={step === 3 ? 24 : 20} alt="personalize image" />
            <p className='flex-1 text-sm font-semibold ml-3'>{name}</p>
            {step !== 2 && <FontAwesomeIcon icon={faChevronRight} className='text-lg mr-1'/>}
        </div>
    )
}

export default SingleList